"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.shared.yes': 'Yes',
    'step.shared.no': 'No',
};
